export default {
	CSV_DATE_RANGE_HEADER: 'Select a date range for the CSV data',
	DOWNLOAD: 'Download'
};
